import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Slider from '@argos/slider'
import ProductCard from '@argos/product-card'
import ContentLoader from 'react-content-loader'
import { pushEventAndTrack, pushRecommendation } from '../../helpers/TaggingSerializer'
import { promoCardLayoutBreakdown } from '../../helpers/TaggingHelper'

import { breakpointPx } from '../../helpers/ContentHelper'
import './PromotionPanel.scss'

class PromotionPanel extends Component {
  constructor(props) {
    super(props)
    this.trackSlider = this.trackSlider.bind(this)
    this.renderSlider = this.renderSlider.bind(this)
    this.updateDigitalDataObject = this.updateDigitalDataObject.bind(this)
    this.impressionsFired = []
  }

  componentDidMount() {
    this.updateDigitalDataObject()
    this.fireBeacon()
  }

  updateDigitalDataObject() {
    const { title, source, data } = this.props
    if (global.window && !data.error && !data.loading) {
      const recommendationInfo = {
        title,
        source,
        ...this.displayedList(1),
      }
      const eventTrackingInfo = {
        eventInfo: { ...this.props.tracking },
        attributes: {
          recommendations: recommendationInfo,
        },
      }

      pushRecommendation(recommendationInfo)
      pushEventAndTrack(eventTrackingInfo)
    }
  }

  fireBeacon() {
    const { data } = this.props
    if (!data.pageBeacon) return
    const currentSlide = 1
    const itemCount = this.displayedList(currentSlide).cardDisplay
    const items = data.products.slice(...itemCount)
    items.forEach((item) => {
      if (item.attributes.tracking) {
        const img = document.createElement('img')
        img.src = item.attributes.tracking.ImpBeacon
        img.width = 1
        img.height = 1
        img.style.visibility = 'hidden'
        img.className = 'sr-hidden hl-pixel'
        img.alt = 'hook logic component tracking pixel'

        document.body.appendChild(img)
      }
    })
  }

  displayedList(currentSlide) {
    const { data } = this.props
    if (!data.products) return null
    const definedQueries = [
      `(min-width: ${breakpointPx.LARGE}px)`,
      `(min-width: ${breakpointPx.MEDIUM}px)`,
      `(min-width: ${breakpointPx.SMALL}px)`,
      `(min-width: ${breakpointPx.MOBILE}px)`,
    ]

    const matchingQuery = definedQueries.findIndex((item) => window.matchMedia(item).matches)
    const viewportCount = matchingQuery === 0 ? 4 : matchingQuery === 1 ? 3 : 2

    const validProducts = data.products.filter((validProduct) => validProduct)
    const fullList = validProducts.map((product) => product.id)

    const cardDisplay = promoCardLayoutBreakdown[viewportCount][currentSlide]
    const firstActiveCard = cardDisplay[0]
    const lastActiveCard = cardDisplay[1] > fullList.length ? fullList.length : cardDisplay[1]

    return {
      displayedList: fullList.slice(firstActiveCard, lastActiveCard),
      cardDisplay,
      fullList,
    }
  }

  trackSlider(currentSlide) {
    const { title, data } = this.props
    const { pageBeacon, products } = data

    const eventTrackingInfo = {
      eventInfo: {
        eventName: 'hp_recommendationsNewPage',
        eventAction: 'Recommendations New Page',
      },
      attributes: {
        recommendations: {
          title,
          ...this.displayedList(currentSlide),
        },
      },
    }

    pushEventAndTrack(eventTrackingInfo)

    if (!pageBeacon) return
    const itemCount = this.displayedList(currentSlide).cardDisplay
    const items = products.slice(...itemCount)
    items.forEach((item) => {
      if (this.impressionsFired.indexOf(item.id) < 0 && item.attributes && item.attributes.tracking) {
        this.impressionsFired.push(item.id)
        const img = document.createElement('img')
        img.src = item.attributes.tracking.ImpBeacon
        img.width = 1
        img.height = 1
        img.style.visibility = 'hidden'
        img.className = 'sr-hidden hl-pixel'

        document.body.appendChild(img)
      }
    })
  }

  renderSlider(products) {
    const renderProductCard = (product, index) => {
      let productUrl = `/product/${product.id}`
      const isTuProduct = product.id.indexOf('TU') > -1
      const calculatePage = (i) => {
        const pages = 4
        return Math.ceil((i + 1) / pages)
      }
      const taggingParameters = {
        site: 'HP',
        section: this.props.section,
        page: `p${calculatePage(index)}`,
        shortTitle: this.props.title
          .match(/\b(\w)/g)
          .join('')
          .toUpperCase(),
        strategy: this.props.source,
        productId: product.id,
      }

      if (product.attributes.tracking) {
        productUrl = product.attributes.tracking.ProductPage
      } else {
        const { site, section, page, shortTitle, strategy, productId } = taggingParameters
        const params = `?rec=${site}:${section}:${page}:${shortTitle}:${strategy}:${productId}`
        productUrl = `/product/${product.id + params}`
      }

      return (
        <ProductCard
          className='promotion-panel__product'
          partNumber={product.id}
          productLink={productUrl}
          name={product.attributes.name}
          price={product.attributes.price && product.attributes.price.now}
          hasMultiplePrices={product.attributes.variants && product.attributes.variants.length > 0}
          displaySpecialOfferText
          displayWasPrice={!isTuProduct}
          specialOfferText={product.attributes.price && product.attributes.price.flashText}
          wasPrice={product.attributes.price && product.attributes.price.was}
        />
      )
    }

    const slideProps = {
      itemsPerSlideXs: 2,
      itemsPerSlideSm: 2,
      itemsPerSlideMd: 3,
      itemsPerSlideLg: 4,
      isInfiniteCycle: true,
      className: 'promotion-panel',
      showChevrons: true,
      onSlideChanged: this.trackSlider,
    }
    const productSlides = products.map((product, index) => (
      <div key={index} className='xs-6--none md-4--none lg-3--none'>
        {renderProductCard(product, index)}
      </div>
    ))
    if (products.length !== productSlides.length) return null
    return <Slider {...slideProps} items={productSlides} />
  }

  render() {
    this.updateDigitalDataObject()

    const { data, title } = this.props
    const { loading, products, error, pageBeacon } = data

    if (error) return null

    const contentLoaderProps = {
      height: 100,
      width: 100,
      speed: 1,
      primaryColor: '#f3f3f3',
      secondaryColor: '#ecebeb',
      preserveAspectRatio: 'none',
    }
    const skeletonProductCard = [
      <Fragment key={'skeleton-card'}>
        <ContentLoader className={'skeleton-product-image'} {...contentLoaderProps}>
          <rect x='0' y='0' rx='0' ry='0' width='100' height='100' />
        </ContentLoader>
        <ContentLoader className={'skeleton-product-text'} {...contentLoaderProps}>
          <rect x='0' y='0' rx='0' ry='0' width='100' height='30' />
          <rect x='8' y='40' rx='0' ry='0' width='85' height='30' />
        </ContentLoader>
      </Fragment>,
    ]

    const validProducts = !loading && products && products.filter((validProduct) => validProduct)

    return (
      <div className='promotion-panel' data-test={title.toLowerCase()}>
        {title && <h2 className='text-center'>{title}</h2>}

        {loading && (
          <div className='promotion-panel__skeleton-wrapper xs-row xs-12--negative'>
            <div className='xs-12 xs-row md-hidden'>
              <div className='xs-6'>{skeletonProductCard}</div>
              <div className='xs-6'>{skeletonProductCard}</div>
            </div>
            <div className='xs-12 xs-hidden md-row lg-hidden'>
              <div className='xs-4'>{skeletonProductCard}</div>
              <div className='xs-4'>{skeletonProductCard}</div>
              <div className='xs-4'>{skeletonProductCard}</div>
            </div>
            <div className='xs-12 xs-hidden lg-row'>
              <div className='xs-3'>{skeletonProductCard}</div>
              <div className='xs-3'>{skeletonProductCard}</div>
              <div className='xs-3'>{skeletonProductCard}</div>
              <div className='xs-3'>{skeletonProductCard}</div>
            </div>
          </div>
        )}

        {validProducts && (
          <div className='xs-row xs-12--negative promotion-panel__slider-container'>
            {this.renderSlider(validProducts)}
          </div>
        )}

        {pageBeacon !== undefined && (
          <img
            src={pageBeacon}
            width='1'
            height='1'
            style={{ visibility: 'hidden' }}
            className='sr-hidden hl-pixel-global'
            alt='hook logic component tracking pixel'
          />
        )}
      </div>
    )
  }
}

PromotionPanel.propTypes = {
  data: PropTypes.shape({
    error: PropTypes.bool,
    loading: PropTypes.bool,
    pageBeacon: PropTypes.string,
    products: PropTypes.shape([]),
    recommendations: PropTypes.shape([]),
  }),
  section: PropTypes.string,
  source: PropTypes.string,
  title: PropTypes.string,
  tracking: PropTypes.shape({
    eventAction: PropTypes.string,
    eventName: PropTypes.string,
  }),
}

export default PromotionPanel
